export enum GradualReleaseLabels {
  MOCKED_RELEASE_LABEL = 'MOCKED_RELEASE_LABEL', // for testing purposes
  LOGIN_MACHINE_REFRESH = 'LOGIN_MACHINE_REFRESH',
  THIRD_PARTY_REDIRECT_MACHINE = 'THIRD_PARTY_REDIRECT_MACHINE',
  LOGIN_MACHINE_UPDATE_CONSENT = 'LOGIN_MACHINE_UPDATE_CONSENT',
  TEMPLATE = 'TEMPLATE',
  BAC_PROVIDERS = 'BAC_PROVIDERS_50',
  BTRX_PROVIDERS = 'BTRX_PROVIDERS_50',
  CREDENTIALS_LOADING_SCREEN = 'CREDENTIALS_LOADING_SCREEN',
  PAYMENT_CONSENT_SCREEN_DE_50 = 'PAYMENT_CONSENT_SCREEN_DE_50',
  PAYMENT_CONSENT_SCREEN_100 = 'PAYMENT_CONSENT_SCREEN_100',
  ACCOUNT_SELECTION_SCREEN_AC_50 = 'ACCOUNT_SELECTION_SCREEN_AC_50',
  XSTATE_CREDENTIALS_MACHINE = 'XSTATE_CREDENTIALS_MACHINE',
  DEFAULT_FLOWS_PROVIDER_LIST_50 = 'DEFAULT_FLOWS_PROVIDER_LIST_50',
  DEFAULT_FLOWS_BRANCH_SELECTION_AB_50 = 'DEFAULT_FLOWS_BRANCH_SELECTION_AB_50',
  DEFAULT_FLOWS_REGION_SELECTION_40 = 'DEFAULT_FLOWS_REGION_SELECTION_40',
  DEFAULT_FLOWS_REGION_SELECTION_AB_20 = 'DEFAULT_FLOWS_REGION_SELECTION_AB_20',
  XSTATE_CREDENTIALS_MACHINE_FR_REDIRECT_10 = 'XSTATE_CREDENTIALS_MACHINE_FR_REDIRECT_10',
  XSTATE_CREDENTIALS_MACHINE_AC_DE_EMBEDDED_10 = 'XSTATE_CREDENTIALS_MACHINE_AC_DE_EMBEDDED_10',
  DEFAULT_FLOWS_LOADING_SPINNER = 'DEFAULT_FLOWS_LOADING_SPINNER_SUBMIT_CREDENTIALS_SCREEN',
}

export enum TestExposure {
  IN_TEST = 'IN_TEST',
  OUTSIDE_TEST_WITH_EXPERIMENTAL_FEATURE = 'OUTSIDE_TEST_WITH_EXPERIMENTAL_FEATURE',
  OUTSIDE_TEST = 'OUTSIDE_TEST',
}
